import { createRoot } from 'react-dom/client';

// third party
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import zeutecConfig from './zeutecConfig';

// font imports
import "@fontsource/lato";

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        {/* <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter> */}
        <HashRouter basename={zeutecConfig.basename}>
            <App />
        </HashRouter>
    </Provider>
);

// If you want the app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
